(function ($, w) {
    /**
     * @param widget_name
     * @param token
     * @param active_block
     */
    var SpecialOffers = {
        init : function (options) {
            this.ops = $.extend({
                widget_name: 'special_offers',
                token: null,
                active_block: null,
                activeClass: '__active',
                settingsStorage: {
                    type: 'session'
                }
            }, options);

            var widget_name = this.ops.widget_name,
                token = this.ops.token,
                active_block = this.ops.active_block,
                activeClass = this.ops.activeClass;
            var cache = {
                store: {},
                write: function (key, data) {
                    this.store[key] = data;
                },
                read: function (key) {
                    return this.store[key] != undefined ? this.store[key] : false;
                }
            };
            var self = this;
            var container = $("#special_offers_" + token);
            cache.write(active_block, container.find('.j-special-offers-content').html());

            var tabs = container.find('.j-special-offers-tab');
            tabs.off('click').on('click', function () {
                var data = {
                    token: token,
                    settingsStorage: self.ops.settingsStorage
                };
                var me = $(this),
                    name = me.attr('rel');

                var init_html = function (html) {
                    tabs.removeClass(activeClass);
                    me.addClass(activeClass);
                    container.find('.j-special-offers-content').html(html);
                    self.trigger('onChange');
                };
                var html;
                if (html = cache.read(name)) {
                    init_html(html);
                } else {
                    self.trigger('onBeforeAjax', container);
                    sendAjax(GLOBAL.URI_PREFIX + '_widget/' + widget_name + '/block/' + name + '/', data, function (status, response) {
                        self.trigger('onAjax', container);
                        if (status === 'OK') {
                            cache.write(name, response.html);
                            init_html(response.html);

                        }
                        self.trigger('onAfterAjax', container);
                    });
                }

                return false;
            });
        }
    };
    $.extend(SpecialOffers, TMEvents);
    w.SpecialOffers = SpecialOffers;
})(jQuery, window);